import { LinearProgress, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { type ITheme } from '../../theme';

const useStyles = makeStyles()((theme: ITheme) => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(),
    padding: theme.spacing(),
  },

  progressBar: {
    flexGrow: 1,
  },
}));

export interface UploadProgressProps {
  progress: number;
}

const UploadProgress = ({ progress }: UploadProgressProps): JSX.Element => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.mainContainer}>
      <Typography variant="body2" color="textPrimary">
        {t('home.input.uploading')}
      </Typography>
      <LinearProgress className={classes.progressBar} variant="determinate" value={progress} />
      <Typography variant="body2" color="textSecondary">
        {`${Math.round(progress)}%`}
      </Typography>
    </div>
  );
};

export default UploadProgress;
